import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';

export class PrivateStockValueType extends Enum {
  key!: string;
  value!: string;

  static TOTAL_VALUE: PrivateStockValueType = {
    key: 'total_value',
    get value(): string {
      return Lang.t('asset.total-business-value');
    }
  };

  static PER_SHARE_VALUE: PrivateStockValueType = {
    key: 'per_share_value',
    get value(): string {
      return Lang.t('asset.per-share-value');
    }
  };
}
